export default __webpack_public_path__ + "static/media/grafema_SET_07.667e0ed0.jpg";